import { Injectable } from '@angular/core';

@Injectable()
export class AvailablestepsService {

    messageVariablesCategory: any = [
        {
          "categoryTitle" : "CONTACT",
          "categoryCode" : "contact",
          "allowedflow" : null,
          "variables" : [
            {
              "title" : "Voornaam",
              "formula" : "%fname%",
            },
            {
              "title" : "Achternaam",
              "formula" : "%lname%"
            },
            {
              "title" : "Telefoon",
              "formula" : "%phone%"
            },
            {
              "title" : "Email",
              "formula" : "%email%"
            },
            {
              "title" : "Lead Id",
              "formula" : "%leadid%"
            }
          ]
        },
        {
          "categoryTitle" : "APPOINTMENT",
          "categoryCode" : "appointment",
          "allowedflow" : ['appointment'],
          "variables" : [
            {
              "title": "Naam afspraaktype",
              "formula": "%atype%",
              "isEnable": true
            },
            {
              "title": "Afspraakduur",
              "formula": "%duration%",
              "isEnable": true
            },
            {
              "title": "Afspraakdatum en tijd",
              "formula": "%datetime%",
              "isEnable": true
            },
            {
              "title": "Team/ vestiging",
              "formula": "%office%",
              "isEnable": true
            },
            {
              "title": "Link - afspraak inplannen",
              "formula": "%slink%",
              "isEnable": true
            },
            {
              "title": "Link - toevoegen aan Outlook agenda",
              "formula": "%ical%",
              "isEnable": true
            },
            {
              "title": "Link - toevoegen aan Google agenda",
              "formula": "%gcal%",
              "isEnable": true
            },
            {
              "title": "Link - afspraak verplaatsen/ annuleren",
              "formula": "%rclink%",
              "isEnable": true
            },
            {
              "title": "Vacature",
              "formula": "%sourcename%",
              "isEnable": true
            },
            {
              "title": "Afspraakdatum",
              "formula": "%date%",
              "isEnable": true
            },
            {
              "title": "Tijdslot starttijd",
              "formula": "%starttime%",
              "isEnable": true
            },
            {
              "title": "Tijdslot eindtijd",
              "formula": "%endtime%",
              "isEnable": true
            }
            // {
            //   "title": "Conference link",
            //   "formula": "%conflink%",
            //   "isEnable": true
            // }
          ]
        },
        {
          "categoryTitle" : "Automation",
          "categoryCode" : "automation",
          "allowedflow" : ['automation'],
          "variables" : [
            {
              "title": "Automation Name",
              "formula": "%qname%"
            },
            {
              "title": "Automation Link",
              "formula": "%qlink%"
            }
          ]
        },
        {
          "categoryTitle" : "RECRUITER",
          "categoryCode" : "recruiter",
          "allowedflow" : null,
          "variables" : [
            {
              "title" : "Recruiter voornaam",
              "formula" : "%rfname%"
            },
            {
              "title" : "Recruiter telefoon",
              "formula" : "%rphone%"
            },
            {
              "title" : "Signature",
              "formula" : "%signature%",
              "communicationTypeAllowed" : ["emailMsg"]
            }
          ]
        }
      ]
    
    constructor() { }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/availablesteps.service.ts